import { Row } from '@amzn/meridian';
import { compact } from 'es-toolkit';
import type { FC } from 'react';
import type { SharingCardOption } from './constants';
import { SharingOptionCard } from './SharingOptionCard';

export const SharingOptionGroup: FC<{
  options: readonly SharingCardOption[];
  checkedCardId: string | null;
  onSelect: (cardId: string) => void;
  defaultCardId?: string;
  forcedCardId?: string;
  otherEnabledCardIds?: string[];
}> = ({ options, checkedCardId, onSelect, defaultCardId, forcedCardId, otherEnabledCardIds = [] }) => {
  const hasRestrictions = !!(defaultCardId || forcedCardId);
  const enabledCardIds = new Set(
    compact([
      defaultCardId,
      forcedCardId,
      ...otherEnabledCardIds,
    ]),
  );
  return (
    <Row alignmentVertical="stretch" width="100%" wrap="down">
      {options.map((option) => {
        const isDefault = option.id === defaultCardId;
        return (
          <SharingOptionCard
            {...{
              isDefault,
              onSelect,
              option,
            }}
            isChecked={checkedCardId === option.id}
            isDisabled={hasRestrictions && !enabledCardIds.has(option.id)}
            key={option.id}
          />
        );
      })}
    </Row>
  );
};
